// Moderndayoptx theme

/* footer*/
if (document.querySelector('.footer__content-top')) {
  window.addEventListener('load', function () {
    if (window.innerWidth > 769) {
      var heading = document.querySelector('.footer__content-top .footer-block__heading');
      heading.parentNode.classList.remove('open');
    }
  });

  window.addEventListener('resize', function () {
    if (window.innerWidth > 769) {
      var heading = document.querySelector('.footer__content-top .footer-block__heading');
      heading.parentNode.classList.remove('open');
    }
  });

  window.addEventListener('orientationchange', function () {
    if (window.innerWidth > 769) {
      var heading = document.querySelector('.footer__content-top .footer-block__heading');
      heading.parentNode.classList.remove('open');
    }
  });

  var footerHeadings = document.querySelectorAll('.footer__content-top .footer-block__heading');
  footerHeadings.forEach(function (heading) {
    heading.addEventListener('click', function () {
      var windowWidth = window.innerWidth;
      if (windowWidth < 768) {
        heading.parentNode.classList.toggle('open');
      }
    });
  });


  const menuElements = document.getElementsByClassName("footer-block");
  const headingElements = document.getElementsByClassName("footer-block__heading");
  const contentElements = document.getElementsByClassName("footer-block__details-content");
  
  for (let i = 0; i < menuElements.length; i++) {
    const menuElement = menuElements[i];
    const headingElement = headingElements[i];
    const contentElement = contentElements[i];
  
    menuElement.addEventListener("click", function() {
      if (this.classList.contains("open")) {
        headingElement.classList.add("is-open");
        contentElement.classList.add("footer-transition");
      } else {
        headingElement.classList.remove("is-open");
        contentElement.classList.remove("footer-transition");
      }
    });
  }
}

// arrow-toggle (Drawer-menu)

document.addEventListener('DOMContentLoaded', function() {
  var menuOpenings = document.querySelectorAll('.menu-drawer__menu-item');

  menuOpenings.forEach(function(menuOpening) {
    var chevronIcon = menuOpening.querySelector('.icon-chevron-down');

    menuOpening.addEventListener('click', function() {
      if (chevronIcon.classList.contains('icon-chevron-down')) {
        chevronIcon.classList.remove('icon-chevron-down');
        chevronIcon.classList.add('icon-chevron-up');
      } else {
        chevronIcon.classList.remove('icon-chevron-up');
        chevronIcon.classList.add('icon-chevron-down');
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', function() {
  var menuIcon = document.querySelector('.header__icon--menu');
  menuIcon.addEventListener('click', function() {
    var chevronIcons = document.querySelectorAll('.icon-chevron-up');
    for (var i = 0; i < chevronIcons.length; i++) {
      chevronIcons[i].classList.remove('icon-chevron-up');
      chevronIcons[i].classList.add('icon-chevron-down');
    }
  });
});



// underheader-promo hide when (menu-drawer)

window.addEventListener('DOMContentLoaded', () => {
  const menuDrawerContainer = document.querySelector('.menu-drawer-container');
  const underheaderPromotions = document.querySelector('.underheader-promotions');

  menuDrawerContainer.addEventListener('transitionend', () => {
    if (menuDrawerContainer.classList.contains('menu-opening')) {
      underheaderPromotions.classList.add('underheader--hide');
    } else {
      underheaderPromotions.classList.remove('underheader--hide');
    }
  });
});


// button-close (menu-drawer)

document.addEventListener('DOMContentLoaded', function() {
  var closeButton = document.querySelector('.header-inner__button-close');
  var menuDrawer = document.querySelector('.menu-drawer-container');
  var menuIcon = document.querySelector('.header__icon--menu');
  var body = document.querySelector('body');

  closeButton.addEventListener('click', function() {
    menuDrawer.classList.remove('menu-opening');
    menuDrawer.removeAttribute('open');
    menuIcon.setAttribute('aria-expanded', 'false');
    body.classList.remove('overflow-hidden-tablet');
  });
});




// vidget for lenses

window.addEventListener('load', function() {
  var mainPriceElement = document.querySelector('.main-price');
  var totalPriceElement = document.getElementById('avp-productoption-totalpriceadd');

  if (mainPriceElement && totalPriceElement) {
    mainPriceElement.textContent = totalPriceElement.textContent;

    totalPriceElement.addEventListener('DOMSubtreeModified', function() {
      mainPriceElement.textContent = totalPriceElement.textContent;
    });
  }
});



window.addEventListener('load', function() {
  var sameEyesInputs = document.querySelectorAll('.same_eyes input');
  var rightEyeInputs = document.querySelectorAll('.right-eye_var input');
  var leftEyeInputs = document.querySelectorAll('.left-eye_var input');

  sameEyesInputs.forEach(function(input) {
    handleCheckboxChange(input, '.same_eyes', '.same-eyes__inner', '.same-eye__overlay');
  });

  rightEyeInputs.forEach(function(input) {
    handleCheckboxChange(input, '.right-eye_var', '.right-eye__inner', '.right-eye');
  });

  leftEyeInputs.forEach(function(input) {
    handleCheckboxChange(input, '.left-eye_var', '.left-eye__inner', '.left-eye');
  });

  function handleCheckboxChange(input, containerClass, innerDivClass, overlayClass) {
    if (input.checked) {
      var main = input.closest(containerClass);
      var innerDiv = main.querySelector(innerDivClass);

      if (!innerDiv) {
        innerDiv = document.createElement('div');
        innerDiv.classList.add(innerDivClass.slice(1));
        main.appendChild(innerDiv);

        var overlays = document.querySelectorAll(overlayClass);
        overlays.forEach(function(overlay) {
          innerDiv.appendChild(overlay);
        });
      } else {
        innerDiv.style.display = 'flex';
      }
    }

    input.addEventListener('change', function() {
      var main = this.closest(containerClass);
      var innerDiv = main.querySelector(innerDivClass);

      if (this.checked) {
        if (!innerDiv) {
          innerDiv = document.createElement('div');
          innerDiv.classList.add(innerDivClass.slice(1));
          main.appendChild(innerDiv);

          var overlays = document.querySelectorAll(overlayClass);
          overlays.forEach(function(overlay) {
            innerDiv.appendChild(overlay);
          });
        } else {
          innerDiv.style.display = 'grid';
        }
      } else {
        if (innerDiv) {
          innerDiv.style.display = 'none';
        }
      }
    });
  }
});

window.addEventListener('load', function() {
  function addReadOnlyAndDisabledAttributesToParentClassElements(parentClass) {
    const parentElements = document.querySelectorAll('.' + parentClass);
    parentElements.forEach(parentElement => {
      const selectElements = parentElement.querySelectorAll('select');
      selectElements.forEach(selectElement => {
        // selectElement.setAttribute('readonly', true);
        selectElement.setAttribute('disabled', true);
      });
    });
  }

  addReadOnlyAndDisabledAttributesToParentClassElements('right-eye__dia');
  addReadOnlyAndDisabledAttributesToParentClassElements('left-eye__dia');
  addReadOnlyAndDisabledAttributesToParentClassElements('dia_eye');
});



// Plus-Minus

const descriptionOpenElements = document.querySelectorAll('.description-open');
  if(descriptionOpenElements){
  const plusMinusElements = document.querySelectorAll('.plus-minus');
  
  descriptionOpenElements.forEach(function(descriptionOpen, index) {
    const plusMinus = plusMinusElements[index];
  
    descriptionOpen.addEventListener('click', function() {
      const hasRotateClass = plusMinus.classList.contains('plus-minus__rotate');
  
      if (hasRotateClass) {
        plusMinus.classList.remove('plus-minus__rotate');
      } else {
        plusMinus.classList.add('plus-minus__rotate');
      }
    });
  });
}




// Pop-up uper HEADER

const headerElement = document.querySelector('.section-header.shopify-section-group-header-group');
const disclosureElement = document.querySelector('.disclosure-has-popup');

function applyZIndex() {
  headerElement.style.zIndex = '3';
}

function removeZIndex() {
  headerElement.style.zIndex = '';
}

if (disclosureElement) {
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
        const isOpen = disclosureElement.hasAttribute('open');
        if (isOpen) {
          applyZIndex();
        } else {
          removeZIndex();
        }
      }
    });
  });

  observer.observe(disclosureElement, { attributes: true });
}



// Body overflow hidden, when Mega-menu is open

document.addEventListener('DOMContentLoaded', function() {
  const minusIcon = document.querySelector('.icon-minus');
  const plusIcon = document.querySelector('.icon-plus');

  document.addEventListener('click', function(event) {
    if (event.target.classList.contains('collapsible-trigger')) {
      if (minusIcon.style.display === 'none') {
        minusIcon.style.display = 'block';
        plusIcon.style.display = 'none';
      } else {
        minusIcon.style.display = 'none';
        plusIcon.style.display = 'block';
      }
    }
  });
});


// Yelp account pop-up

document.addEventListener("DOMContentLoaded", function () {
  const yelpLinks = document.querySelectorAll('.yelp-choise');

  yelpLinks.forEach(function (yelpLink) {
    const yelpOverlay = yelpLink.querySelector('.yelp-accounts');
    const yelpButtonClose = yelpOverlay.querySelector('.yelp-accounts__button-close');

    yelpButtonClose.addEventListener('click', function (event) {
      yelpOverlay.classList.remove('yelp-overlay');
      event.stopPropagation();
    });

    let timeoutId;

    if (window.innerWidth <= 768) {
      yelpLink.addEventListener('click', function () {
        yelpOverlay.classList.toggle('yelp-overlay');
      });
    } else {
      yelpLink.addEventListener('mouseenter', function () {
        yelpOverlay.classList.add('yelp-overlay');
        clearTimeout(timeoutId);
      });

      yelpLink.addEventListener('mouseleave', function () {
        timeoutId = setTimeout(function () {
          yelpOverlay.classList.remove('yelp-overlay');
        }, 500);
      });

      yelpOverlay.addEventListener('mouseenter', function () {
        clearTimeout(timeoutId);
      });

      yelpOverlay.addEventListener('mouseleave', function () {
        timeoutId = setTimeout(function () {
          yelpOverlay.classList.remove('yelp-overlay');
        }, 500);
      });
    }
  });
});



// Copy Plus Code

document.addEventListener('DOMContentLoaded', function() {
    const copyTextElements = document.querySelectorAll('.plus-code-link');
    const alertButtonClose = document.querySelector('.close-alert');
    
    copyTextElements.forEach(function(copyTextElement) {
        copyTextElement.addEventListener('click', function() {
            const textToCopy = copyTextElement.innerText;
            const tempInput = document.createElement('input');
            tempInput.value = textToCopy;
            document.body.appendChild(tempInput);
            tempInput.select();
            document.execCommand('copy');
            document.body.removeChild(tempInput);
            document.querySelector('.clipboard-alert').classList.remove('hidden');
            setTimeout(() => {
              document.querySelector('.clipboard-alert').classList.add('hidden');
            }, 5000);
        });
    });

    alertButtonClose.addEventListener('click', function(){
      document.querySelector('.clipboard-alert').classList.add('hidden');
    });

    // Colors Accordeon

    const variantWrap = document.querySelector(".product-form__input");
    if(variantWrap){
      const variantInput = variantWrap.querySelectorAll(".variant-picker-js");
      const plusButton = document.createElement("button");
      plusButton.innerText = "+";
    
      if (variantInput.length > 45) {
        for (let i = 44; i < variantInput.length; i++) {
   
          (function (index) {
            plusButton.addEventListener("click", function () {
              variantInput[index].style.display =
                variantInput[index].style.display === "inline-block"
                  ? "none"
                  : "inline-block";
              plusButton.innerText =
                variantInput[index].style.display === "none" ? "+" : "-";
            });
          })(i);
        }
        const lastVariantInput = variantInput[variantInput.length - 1];
        lastVariantInput.insertAdjacentElement("afterend", plusButton);
      }
    }

    // Special Color

      const specialColor = document.querySelector('.special-color');

      if(specialColor) {
        const optionName = specialColor.querySelector('.form__label')
        optionName.innerHTML = `Color Temple`;
      }
  
      const openTemple = document.querySelector(".open-temple");
      if(openTemple){
        
      const popupTemple = document.querySelector(".popup_temple");
      const closeTemple = popupTemple.querySelector(".button-close");
  
      openTemple.addEventListener("click", function () {
        popupTemple.classList.add("temple-modal-open");
        document.querySelector("body").classList.add("body_hidden");
      });
  
      closeTemple.addEventListener("click", function () {
        popupTemple.classList.remove("temple-modal-open");
        document.querySelector("body").classList.remove("body_hidden");
      });
    }


  const colorFieldset = document.querySelectorAll('.blackfin-color')[0];

  if (colorFieldset) {
    const blackfinContainer = document.createElement('div');
    blackfinContainer.classList.add('variant-wrapper', 'js', 'blackfin-pdf');
    blackfinContainer.setAttribute('data-type', 'button');
    
    colorFieldset.appendChild(blackfinContainer);
  }


  
  const blackWrapper = document.querySelector(".blackfin-pdf");

  if (blackWrapper) {
    const blackfinPdf = `
        <label class="form__label">LENSES SHAPE</label>
        <div class="variant-input-wrap" style="display: flex; align-items: center;">
          <div class="variant-input" style="pointer-events: none;">
                <input checked="checked" type="radio" id="special-color">
                <label
                for="special-color"
                class="color-swatch"
                style="background-image: url(https://cdn.shopify.com/s/files/1/0626/4383/1027/files/Ellipse_13_1.png?v=1710510615);">
              </label>
          </div>
          <div class="special-color__text-content" style="font-size: 16px; line-height: 19px">
          Design, create, test. And repeat. <span class="open-blackfin" style="text-decoration: underline; cursor: pointer;">Learn more</span>
          </div>
        </div>
      `;

    blackWrapper.innerHTML = blackfinPdf;

    const openBlackfin = blackWrapper.querySelector(".open-blackfin");
    const popupBlackfin = document.querySelector(".popup_blackfin");
    const closeBlackfin = popupBlackfin.querySelector(".button-close");

    openBlackfin.addEventListener("click", function () {
      popupBlackfin.classList.add("blackfin-modal-open");
      document.querySelector("body").classList.add("body_hidden");
    });

    closeBlackfin.addEventListener("click", function () {
      popupBlackfin.classList.remove("blackfin-modal-open");
      document.querySelector("body").classList.remove("body_hidden");
    });
  }
  
});


























